import { Box } from "@mui/material";
import { HeroBanner, SEO } from "../../components";

const HomePage = () => {
    return (
        <Box
            sx={{
                width: "100%",
                height: "100vh",
                overflow: "hidden",
                position: "relative",
            }}
        >
            <SEO
                title="Spinnaker Algorithms | Quantitative Research, Execution, and Platforms"
                description="Explore Spinnaker Algorithms' products: Swing Vision, Q Alpha Flow, OctopusSync, and Sentinel."
            />
            <HeroBanner />
        </Box>
    );
};

export default HomePage;